import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';
import { approvalKeys } from '@/api/approvals';
import type { ApprovalRequest } from '@/types/approvals';

/**
 * ApprovalBadge — shows pending approval count in navigation.
 * Polls every 60 seconds to keep the count fresh.
 */
export default function ApprovalBadge() {
  const { data: pendingRequests } = useQuery({
    queryKey: approvalKeys.pending(),
    queryFn: async () => {
      const { data } = await apiClient.get<ApprovalRequest[]>('/approvals/requests/pending/');
      return data;
    },
    refetchInterval: 60_000,
  });

  const raw = pendingRequests as any;
  const count = Array.isArray(raw) ? raw.length : (raw?.results?.length ?? 0);

  if (count === 0) return null;

  return (
    <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white">
      {count > 99 ? '99+' : count}
    </span>
  );
}
